module.exports = "/assets/images/gamer.png";